import type { FC } from "react";
import React from "react";
import { useBrand, useFlow } from "@edreamsodigeo/frontend-core";
import { Box } from "@edreamsodigeo/prisma-design-system";

import styles from "~/components/common/BrandBackground/config/constants";

export interface BrandBackgroundProps {
  children?: React.ReactNode;
  overrideSx?: object;
}

const BrandBackground: FC<BrandBackgroundProps> = ({
  children,
  overrideSx = {},
}) => {
  const flow = useFlow(); // Example breakpoint for mobile
  const brand = useBrand();
  const containerStyles =
    styles[brand]?.[flow]?.container ?? styles["ED"][flow].container;
  return (
    <Box
      sx={{ ...containerStyles, ...overrideSx }}
      data-testid={`brand-background-${brand}`}
    >
      {children}
    </Box>
  );
};

export default BrandBackground;
